import * as React from 'react';
import styles from './MarkdownWidget.css';
import marked from 'marked';
import get from 'lodash/get';
export default class MarkdownWidget extends React.PureComponent {
    render() {
        const { widget } = this.props;
        const data = get(widget, 'data.renderableComponents[0].value.content', '');
        return (<div className={styles['markdown']}>
				<div dangerouslySetInnerHTML={{ __html: marked(data) }}/>
			</div>);
    }
}
